import $ from 'jquery';
import IMask from 'imask';

const phoneInputs = $('input.js-phone-mask');
const dateInputs = $('input.js-date-mask');

if (phoneInputs.length) {
    phoneInputs.each((i, input) => {
        IMask(input, {
            mask: '+{7} (000) 000-00-00'
        });
    });
}

if (dateInputs.length) {
    dateInputs.each((i, input) => {
        IMask(input, {
            mask: Date
        });
    });
}
